var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-color-picker',{staticClass:"swatch-color-picker",attrs:{"swatches":_vm.colorSwatches,"update:modelValue":"changeColor","hide-canvas":"","show-swatches":""},model:{value:(_vm.colorPicker),callback:function ($$v) {_vm.colorPicker=$$v},expression:"colorPicker"}})
}
var staticRenderFns = []

export { render, staticRenderFns }